import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconFiberBlack({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<g fill="none" fillRule="evenodd">
				<path
					fill="#CD0400"
					d="M10.016 16.298c0 1.56-1.226 2.824-2.739 2.824S4.54 17.857 4.54 16.298c0-1.56 1.226-2.824 2.738-2.824s2.739 1.264 2.739 2.824"
				/>
				<path
					fill="#CD0400"
					d="M22.277 9.527c-1.006-1.032-2.455-1.203-3.765-1.36-1.427-.14-2.8-.153-4.211-.164-1.321-.012-2.806.002-4.109-.036-.86-.034-1.779-.073-2.588-.31-.464-.137-.967-.33-.873-.883.068-.404.22-.746.772-1.023.6-.302 1.109-.471 1.79-.672 2.623-.774 5.469-.689 8.203-.654.108-.001.108-.15.007-.161a59 59 0 0 0-2.757-.072c-2.31.018-5.968.406-7.935 1.576-.882.515-1.077 1.695-.241 2.362 1.137.876 3.537.916 4.95 1.008 1.32.064 2.8.079 4.116.162 1.326.094 2.658.216 3.892.655.62.248 1.53.643 1.32 1.388-.182.346-.446.518-.854.758-.296.164-.645.31-1.013.438-2.4.782-5.067.95-7.603 1.038-.837.02-1.719.031-2.557-.006a3.14 3.14 0 0 1 1.561 2.727c0 1.73-1.375 3.131-3.07 3.131-.454 0-.884-.1-1.272-.28a3.24 3.24 0 0 0 2.878.797c.15-.036.516-.103.68-.146a53.305 53.305 0 0 0 5.506-1.775c1.882-.741 3.694-1.534 5.388-2.73 1.205-.869 2.507-2.142 2.506-3.767.029-.717-.225-1.489-.72-2"
				/>
				<path
					fill="#000"
					d="M7.556 12.833c-.917 0-1.73.43-2.3 1.098a3 3 0 0 1 1.987-.765c.554 0 1.073.15 1.521.412l.04.023.048.03c.408.25.753.603 1.006 1.024l.017.03.038.066.044.082.007.013c.223.434.35.928.35 1.452v.021c0 1.686-1.267 3.058-2.847 3.108l.09.002c1.719 0 3.113-1.477 3.113-3.298 0-1.822-1.394-3.298-3.114-3.298"
				/>
				<path
					fill="#FF0"
					d="M20.533 10.491s.08-1.256-1.369-1.764c-1.59-.558-3.745-.683-7.387-.683s-5.919-.66-6.033-1.514c0 0-.16 1.65 6.01 1.674 6.17.022 8.563.489 8.78 2.287M22.707 10.31s.145 4.539-12.037 5.808l-.001.104c-.017.532-.14.95-.338 1.406 2.737-.615 12.712-3.133 12.376-7.319"
				/>
				<path
					fill="#CD0400"
					d="m8.638 16.576-4.654.755a.26.26 0 0 1-.298-.215l-.002-.014a.26.26 0 0 1 .214-.298l4.654-.756a.26.26 0 0 1 .298.215l.002.015a.26.26 0 0 1-.214.298M3.048 17.483l-.952.155a.237.237 0 0 1-.272-.196l-.01-.06a.237.237 0 0 1 .196-.272l.952-.154a.237.237 0 0 1 .272.195l.01.06a.237.237 0 0 1-.196.272M7.096 15.617l-3.9.633a.246.246 0 0 1-.282-.204l-.007-.04a.247.247 0 0 1 .204-.283l3.899-.633a.247.247 0 0 1 .283.204l.006.04a.247.247 0 0 1-.203.283M2.207 16.407l-.657.106a.267.267 0 1 1-.086-.527l.657-.106a.267.267 0 1 1 .086.527M8.21 17.79l-4.716.765a.25.25 0 0 1-.288-.208l-.005-.031a.25.25 0 0 1 .207-.288l4.717-.766a.25.25 0 0 1 .288.208l.005.031a.25.25 0 0 1-.207.288M2.512 18.71l-.657.107a.267.267 0 1 1-.086-.527l.657-.107a.267.267 0 1 1 .086.527"
				/>
				<path
					fill="#FF0"
					d="m8.398 16.369-4.654.755a.26.26 0 0 1-.298-.214l-.002-.015a.26.26 0 0 1 .214-.298l4.654-.755a.26.26 0 0 1 .298.214l.002.015a.26.26 0 0 1-.214.298M2.852 17.27l-.952.154a.237.237 0 0 1-.272-.196l-.01-.06a.237.237 0 0 1 .196-.272l.952-.154a.237.237 0 0 1 .272.195l.01.06a.237.237 0 0 1-.196.272M6.856 15.41l-3.879.63a.246.246 0 0 1-.282-.204l-.007-.041a.246.246 0 0 1 .204-.283l3.879-.63c.134-.021.26.07.282.204l.006.042a.246.246 0 0 1-.203.282M1.967 16.2l-.657.107a.267.267 0 1 1-.086-.527l.657-.107a.267.267 0 1 1 .086.527M7.994 17.579l-4.717.765a.25.25 0 0 1-.288-.207l-.005-.032a.25.25 0 0 1 .208-.288l4.717-.766a.25.25 0 0 1 .288.208l.005.032a.25.25 0 0 1-.208.288M2.272 18.504l-.657.106a.267.267 0 1 1-.086-.527l.657-.107a.267.267 0 1 1 .086.527"
				/>
				<path
					fill="#000"
					d="M21.852 8.743c-1.317-1.197-3.563-1.262-5.265-1.39-2.095-.115-4.192-.066-6.286-.09-1.027-.028-2.095-.033-3.077-.337-.538-.166-.77-.571-.347-1 .559-.524 1.351-.74 2.08-.932 2.806-.65 5.703-.752 8.576-.748.078.004.114-.094.058-.147-.027-.025-.064-.023-.095-.024l-.099-.006c-2.481-.102-4.985-.117-7.457.137-.52.064-1.04.14-1.554.247-.766.168-1.588.36-2.214.864-.67.573-.729 1.644-.053 2.236.42.363.936.544 1.456.686 3.6.797 7.356.137 10.938.991.663.182 2.628.752 1.836 1.707-.347.331-.875.518-1.333.684-.969.344-1.99.533-3.014.642-2.034.208-4.196.17-6.243.258-.304.013-.973.038-1.269.046-1.309.022-2.71.62-3.494 1.675a3.04 3.04 0 0 1 2.315-1.076c.412 0 .805.084 1.164.234l.033-.001.099-.002.396-.01c2.345-.08 4.77-.112 7.083-.548 1.416-.296 2.933-.577 4.11-1.49C22.03 9.673 18.136 8.91 17 8.784c-2.088-.27-4.193-.23-6.278-.363-1.402-.111-5.385-.165-4.81-2.35.142-.493.58-.808 1.026-1.017a8 8 0 0 1 1.464-.528c2.041-.486 4.16-.48 6.246-.503.76-.006 1.592.02 2.356.042l.393.017.098.005c.032.002.066-.001.09.02.055.043.017.14-.052.134-2.746-.06-5.52-.001-8.229.51-.86.194-2.43.508-2.815 1.395-.465 1.388 2.976 1.319 3.806 1.373 2.095.057 4.19.01 6.282.065 1.041.035 2.087.102 3.11.297.508.101 1.009.252 1.463.499 1.246.639 1.739 1.937 1.411 3.271-.338 1.267-1.385 2.18-2.424 2.902-3.043 2.01-6.565 3.167-10.047 4.18-.447.126-.87.233-1.325.324a3.01 3.01 0 0 1-2.712.098c.291.186.61.33.952.42.821.246 1.646.083 2.463-.13 2.794-.765 5.537-1.71 8.146-2.988a17.6 17.6 0 0 0 2.712-1.641c.839-.646 1.627-1.415 2.085-2.383.576-1.185.465-2.784-.559-3.69"
				/>
			</g>
		</svg>
	);
}
